<template>
  <oct-file-selector
    :image.sync="$_octUploader_image"
    :multiple="multiple"
    :size="size"
    :type="type"
    @change="upload"
  />
</template>

<script>
import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js';
import OctFileSelector from '@/components/file-selector/OctFileSelector.vue';

export default {
  name: 'OctUploader',
  components: { OctFileSelector },
  props: {
    /** Image */
    image: {
      type: Object,
      default () {
        return {
          lowResolution: '',
          standardResolution: ''
        }
      }
    },
    /** Images used if multiple */
    images: {
      type: Array,
      default: () => []
    },
    /** Multi selection */
    multiple: {
      type: Boolean,
      default: false
    },
    /** Size */
    size: {
      type: String,
      default: 'medium'
    },
    /** Type [default | minimal] */
    type: {
      type: String,
      default: 'default'
    },
    /** Access token for Auth0 */
    token: {
      type: String,
      default: ''
    }
  },
  computed: {
    /** Delegate image prop */
    $_octUploader_image: {
      get () {
        return this.image
      },
      set (val) {
        this.$emit('update:image', val)
      }
    },
    /** Delegate multiple image prop */
    $_octUploader_images: {
      get () {
        return this.images
      },
      set (val) {
        this.$emit('update:images', val)
      }
    }
  },
  methods: {
    async upload (input) {
      // Ignore cancel operation
      if (!input.files.length) return

      // Promises
      const promises = []

      // Process all inputs
      Array.from(input.files).forEach(item => {
        // Upload and update image object
        promises.push(OctApiAdaptor.upload(item, this.token))
      })

      try {
        const files = await Promise.all(promises)

        // After all promises are resolved
        if (this.multiple) {
          this.$_octUploader_images = files

          /** @event 'uploaded' */
          this.$emit('uploaded', files, input.files)
        } else {
          this.$_octUploader_image = files[0]

          /** @event 'uploaded' */
          this.$emit('uploaded', files[0], input.files[0])
        }
      } catch (thrown) {
        alert('ファイルのアップロードに失敗しました')
        console.log(thrown)
      }
    }
  }
}
</script>